<template>
  <div class="row">
    <div class="col-12">
      <card>
        <vue-element-loading
          :active="loading.active"
          :color="loading.color"
          :is-full-screen="false"
          :text="loading.text"
          spinner="bar-fade-scale"/>
        <div>
          <div class="col-sm-12 card">
            <el-table :data="tableData"
                      size="mini"
                      stripe
                      style="width: 100%;">
              <el-table-column :key="column.label"
                               :label="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               v-for="column in tableColumns">
              </el-table-column>
              <el-table-column
                :min-width="120"
                fixed="right"
                label="Actions">
                <template slot-scope="props">
                  <a @click="update(props.row)" class="px-1 btn-info btn-simple btn-link"
                     v-tooltip.top-center="'Editar'">
                    <i class="fa fa-align-justify"></i>
                  </a>
                  <a @click="showSwal('delete', props.row.id)" class="px-1 btn-danger btn-simple btn-link"
                     v-tooltip.top-center="'Eliminar'">
                    X
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </card>
    </div>
    <el-dialog
      :append-to-body="true"
      :modal-append-to-body="false"
      :visible.sync="change"
      center>
      <div>
        <form id="edit_form">
          <div class="row">
            <div class="col-md-6">
              <fg-input :error="getError('name')"
                        label="Nombre"
                        name="name"
                        placeholder="Nombre de la Opcion"
                        type="text"
                        v-model="device.name"
                        v-validate="modelValidations.name"
              >
              </fg-input>
            </div>
          </div>
          <div class="text-right">
            <button @click.prevent="validate" class="btn btn-filmker-pink btn-fill btn-sm" type="submit">
              Editar Opcion
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import {Dialog, Option, Select, Table, TableColumn} from 'element-ui'
  import {Pagination as LPagination} from 'src/components/index'
  import vueElementLoading from 'vue-element-loading'

  export default {
    components: {
      LPagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      vueElementLoading,
      [Dialog.name]: Dialog,
    },
    data() {
      return {
        users: [],
        loading: {
          text: 'Please Wait',
          color: '#222',
          active: false
        },
        contacts: [],
        change: false,
        searchQuery: '',
        propsToSearch: ['email'],
        tableColumns: [
          {
            prop: 'option_name',
            label: 'Nombre',
            minWidth: 150
          },
        ],
        tableData: [],
        device: {
          name: '',
          options: ''
        },
        account: {},
        modelValidations: {
          name: {
            required: true
          },
        }
      }
    },
    methods: {
      validate() {
        this.$validator.validateAll().then(isValid => {
          if (isValid)
            this.addDevice();
        })
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      changePage() {
        this.loadUsers()
      },
      loadUsers() {
        this.loading.active = true
        this.axios({
          url: `conexions.php?datos=25`,
          method: 'get',
          headers: {
            authorization: localStorage.token
          }
        })
          .then(response => {
            this.loading.active = false
            this.tableData = response.data.message
          })
          .catch(error => {
            this.loading.active = false
          })
      },
      handleDelete(id) {
        this.loading.active = true
        this.axios({
          url: `conexions.php?deleteOption=${id}`,
          method: 'delete',
          headers: {
            authorization: localStorage.token
          }
        })
          .then(response => {
            this.loading.active = false
            this.loadUsers()
            swal({
              title: 'Deleted!',
              text: response.message,
              type: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
          })
          .catch(error => {
            this.loading.active = false
            swal({
              title: 'Deleted!',
              text: error.response.message,
              type: 'error',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
          })
      },
      update(id) {
        this.change = true
        this.device.name = id.name;
        this.device.options = id.id;
      },
      showSwal(type, id) {
        if (type === 'delete') {
          swal({
            title: '¿Esta seguro?',
            text: `Esta operación no puede ser revertida!`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Eliminar',
            buttonsStyling: false
          }).then((action) => {
            if (action.value) {
              this.handleDelete(id)
            }
          })
        }
      },
      addDevice() {
        this.loading.active = true
        this.axios({
          url: `conexions.php`,
          method: 'put',
          data: this.device,
          headers: {
            authorization: localStorage.token
          }
        })
          .then(response => {
            this.loading.active = false
            this.change = false
            this.clearModel()
            this.loadUsers()
            this.showSwal('success', 'Opcion Modificada')
          })
          .catch(error => {
            this.loading.active = false
            this.showSwal('error', error.response.data.messages)
          })
      },
      clearModel() {
        this.device = {
          name: '',
          options: ''
        }
      }
    },
    created() {
      this.loadUsers(1)
    },
    mounted() {
    },
    watch: {
      searchQuery(value) {
        this.loadUsers(1)
      }
    }
  }
</script>
<style>
</style>
